import _split from "lodash/split"
import _get from "lodash/get"
import moment from "moment"

moment.locale("pt-br")

export const formatInfo = (item) => {
  const dateTime = moment(item.dateTime, "YYYY-MM-DD HH:mm:ss").format(
    "DD/MM/YYYY HH:mm:ss"
  )
  const [data, time] = _split(dateTime, " ")

  return [
    {
      title: "Produto vinculado",
      description: _get(item, "local", "-")
    },
    {
      title: "Data",
      description: data
    },
    {
      title: "Hora",
      description: time
    },
    {
      title: "Gastos",
      description: `${item.volume} MB`
    }
  ]
}



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/utils/formatInfo.js